module.exports = __webpack_public_path__ + "media/Images/tpa-faq-add-document-image1-54529ce9631c82e2178c331e7592c9f5.jpg";